
import brand1 from '../../Images/brands/brand1.jpg';
import brand2 from '../../Images/brands/brand2.jpg';
import brand3 from '../../Images/brands/brand3.jpg';
import brand4 from '../../Images/brands/brand4.jpg';
import brand5 from '../../Images/brands/brand5.jpg';
import brand6 from '../../Images/brands/brand6.jpg';
import brand7 from '../../Images/brands/brand7.jpg';
import brand8 from '../../Images/brands/brand8.jpg';
import brand9 from '../../Images/brands/brand9.jpg';
import brand10 from '../../Images/brands/brand10.jpg';

const images= {
    brand1,
    brand2,
    brand3,
    brand4,
    brand5,
    brand6,
    brand7,
    brand8,
    brand9,
    brand10,
  };

export default images;